let navigateRef = null;

export const setNavigate = (navigate) => {
    navigateRef = navigate;
};

export const appNavigate = (to, options) => {
    if (navigateRef) {
        navigateRef(to, options);
    } else {
        window.location.replace(to);
    }
};